export default __webpack_public_path__ + "static/media/logo.d630b0cd.svg";